import App from "../App";
import CarDetail from "../sections/CarDetail";

window.App = App;
window.Section = CarDetail;